import { OptionProps } from '@models/interfaces';

export const USER_STATUS_SELECT_OPTIONS: OptionProps[] = [
  { viewValue: 'Active', value: 'true' },
  { viewValue: 'Inactive', value: 'false' },
];
